import { Component } from 'vue-property-decorator';
import AbstractDisplayField from '../abstract-display-field/abstract-display-field';
import { mixins } from 'vue-class-component';
import { forkJoin } from 'rxjs';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';

@Component({
  name: 'bpc-display-field-entity-ids',
  components: {},
})
export default class DisplayFieldEntityIds extends mixins(AbstractDisplayField) {
  i = 1;

  public valueToShow = [];

  mounted() {
    const subscriptions = [];
    this.valueToShow = !Array.isArray(this.value) ? [this.value] : this.value;
    this.valueToShow.forEach(element => {
      const subscription = this.$bpcApi.get(
        `${this.$bpcApiRouteHelper.getEntityPath(this.fieldConfig.entity, 'raw')}/${this.value}`,
      );
      subscriptions.push(subscription);
    });

    forkJoin(subscriptions).subscribe(
      responses => {
        this.valueToShow = responses.map(response => {
          return response['data'][this.fieldConfig.fieldPath];
        });
      },
      error => {
        console.log(error);
      },
    );
  }
}
